import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useState } from "react";
import { useCart } from "../context/CartContext";
import { BRAND } from "../lib/brand";

const links = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/menus", label: "Dessert Menu" },
  { to: "/daily-specials", label: "Specials" },
  { to: "/events", label: "Events" },
  { to: "/blog", label: "Blog" },
  { to: "/faq", label: "FAQ" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

const Navbar = () => {
  const { totalQuantity, openCart } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 glass border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
        <Link
          to="/"
          data-testid="navbar-logo-link"
          className="flex items-center gap-3"
          onClick={() => setMobileOpen(false)}
        >
          <img
            src={BRAND.logo}
            alt={BRAND.name}
            className="h-12 w-12 rounded-full object-cover flicker"
          />
          <span className="font-script text-2xl md:text-3xl neon-gradient-text leading-none">
            {BRAND.name}
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-7 lg:gap-9">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-[0.78rem] uppercase tracking-[0.22em] font-semibold transition-all ${
                  isActive
                    ? "text-white neon-blue"
                    : "text-gray-300 hover:text-white hover:neon-pink"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="navbar-cart-button"
            onClick={openCart}
            className="relative w-11 h-11 rounded-full border border-[#ff1a8c]/60 flex items-center justify-center hover:bg-[#ff1a8c]/10 transition-all"
            aria-label="Open cart"
          >
            <ShoppingBag className="w-5 h-5 text-white" />
            {totalQuantity > 0 && (
              <span
                data-testid="navbar-cart-count"
                className="absolute -top-1.5 -right-1.5 min-w-[20px] h-5 px-1 rounded-full bg-[#00b4ff] text-black text-[11px] font-bold flex items-center justify-center neon-frame-blue"
              >
                {totalQuantity}
              </span>
            )}
          </button>

          <button
            data-testid="navbar-mobile-toggle"
            className="md:hidden w-11 h-11 rounded-full border border-white/15 flex items-center justify-center"
            onClick={() => setMobileOpen((o) => !o)}
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div
          data-testid="navbar-mobile-menu"
          className="md:hidden border-t border-white/10 bg-black/80 backdrop-blur-xl"
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-base uppercase tracking-[0.2em] font-semibold ${
                    isActive ? "neon-blue" : "text-gray-300"
                  }`
                }
                onClick={() => setMobileOpen(false)}
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
